/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The AqaCipherKey model module.
 * @module model/AqaCipherKey
 * @version v0
 */
export default class AqaCipherKey {
  /**
   * Constructs a new <code>AqaCipherKey</code>.
   * @alias module:model/AqaCipherKey
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaCipherKey</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaCipherKey} obj Optional instance to populate.
   * @return {module:model/AqaCipherKey} The populated <code>AqaCipherKey</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaCipherKey();
      if (data.hasOwnProperty('algorithm'))
        obj.algorithm = ApiClient.convertToType(data['algorithm'], 'String');
      if (data.hasOwnProperty('encoded'))
        obj.encoded = ApiClient.convertToType(data['encoded'], 'Blob');
      if (data.hasOwnProperty('format'))
        obj.format = ApiClient.convertToType(data['format'], 'String');
      if (data.hasOwnProperty('destroyed'))
        obj.destroyed = ApiClient.convertToType(data['destroyed'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {String} algorithm
 */
AqaCipherKey.prototype.algorithm = undefined;

/**
 * @member {Blob} encoded
 */
AqaCipherKey.prototype.encoded = undefined;

/**
 * @member {String} format
 */
AqaCipherKey.prototype.format = undefined;

/**
 * @member {Boolean} destroyed
 */
AqaCipherKey.prototype.destroyed = undefined;

